var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_75_368)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.911 20.4827L30.2834 13.9572C31.0433 13.6734 31.707 14.1488 31.4607 15.3366L31.4621 15.3351L28.6745 28.9113C28.4679 29.8739 27.9146 30.1079 27.1405 29.6544L22.8953 26.4202L20.8477 28.4593C20.6213 28.6934 20.4302 28.8909 19.9916 28.8909L20.293 24.425L28.1608 17.0773C28.5032 16.7658 28.0844 16.5902 27.633 16.9003L17.91 23.2284L13.7186 21.8768C12.8087 21.5783 12.7889 20.9362 13.911 20.4827Z",
    fill: "#626975"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_75_368",
    x: 0.428572,
    y: 0.714286,
    width: 45.1429,
    height: 45.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.28571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.705882 0 0 0 0 0.72549 0 0 0 0 0.780392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_368",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.81e73be2b03b8dcdf9e9deabd9e86d07.svg";
export { ForwardRef as ReactComponent };